import axios from 'axios'
import { showToast } from '@/composables/useToast'

const request = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  timeout: 20000
})

request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('factory_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => Promise.reject(error)
)

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status
    const message = error.response?.data?.message || error.message

    if (status === 401) {
      localStorage.removeItem('factory_token')
      window.location.href = '/login'
      return Promise.reject(error)
    }

    // 统一弹 Toast，500/502/503 不弹（服务端宕机时不骚扰用户）
    if (status && status >= 400 && status < 500) {
      showToast(message || '请求失败', 'error', 4000)
    }

    return Promise.reject(error)
  }
)

export default request
